<template>
    <div id="staffManage">
        <div class="breadcrumb">
            <el-breadcrumb separator=">">
                <el-breadcrumb-item>员工管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div style="margin:10px 0" align="left">
            <el-row :gutter="10">
                <el-col align="left" :span="16">
                    <el-button type="primary"  @click="addDialog = true" size="small">添加员工</el-button>
                </el-col>
                <el-col align="center" :span="7">
                    <el-input v-model="staffName" size="small" placeholder="请输入员工姓名" clearable @keyup.enter.native="query()"></el-input>
                </el-col>
                    <el-col align="center" :span="1">
                    <el-button icon="el-icon-search" size="small" circle @click="getStaffList(1)"></el-button>
                </el-col>
            </el-row>
        </div>
        <div>
            <template class="table">
                <el-table :data="staffList" ref="staffList"  style="width: 100%">
                    <el-table-column type="index" align="center" label="序号" > </el-table-column>
                    <el-table-column prop="staffName" align="center" label="姓名" > </el-table-column>
                    <el-table-column prop="staffGender" align="center" label="性别" :formatter="transfSex"> </el-table-column>
                    <el-table-column prop="staffAge" align="center" label="年龄" > </el-table-column>
                    <el-table-column prop="staffTel" align="center" label="电话"></el-table-column>
                    <el-table-column prop="" align="center" label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="resetPwd(scope.row)" size="small">重置密码</el-button>
                            <el-button type="text" @click="deleteStaff(scope.row)" size="small" style="color:red">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
        </div>
        <div class="page">
            <el-pagination  :page-size="15" :page-count="5" layout="total, prev, pager, next" :total="count" @current-change='changePage' style="text-align:right"></el-pagination>
        </div>
        <!-- 添加员工弹窗 -->
        <el-dialog title="添加员工" :visible.sync="addDialog" :close-on-press-escape=false width="630px">
            <el-form :model="addForm" :rules="addStaff" ref="addForm" label-width="100px">
                <el-form-item label="姓名" prop="staffName">
                    <el-input v-model="addForm.staffName" placeholder="请输入员工姓名"></el-input>
                </el-form-item>
                <el-form-item label="性别" prop="staffGender">
                    <el-radio-group v-model="addForm.staffGender" class="radioGroup">
                        <el-radio v-model="addForm.staffGender" label="M">男</el-radio>
                        <el-radio v-model="addForm.staffGender" label="F">女</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="年龄" prop="staffAge">
                    <el-input v-model="addForm.staffAge" placeholder="请输入员工年龄"></el-input>
                </el-form-item>
                <el-form-item label="电话" prop="staffTel">
                    <el-input v-model="addForm.staffTel" placeholder="请输入员工电话，该电话将作为账号使用"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                    <el-input type="password" v-model="addForm.password" placeholder="请输入密码"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="passwordTwo">
                    <el-input type="password" v-model="addForm.passwordTwo" placeholder="请再次输入密码"></el-input>
                </el-form-item>
            </el-form>
            <el-button @click="cancel()">取 消</el-button>
            <el-button type="primary" @click="addStaffFn()">添加</el-button>
        </el-dialog>
    </div>
</template>

<script>
import {isvalidPhone} from '@/service/common'
import { Loading } from 'element-ui';
//定义一个全局的变量，手机号格式验证
var validPhone=(rule, value,callback)=>{
    if (!value){
        callback(new Error('请输入电话号码'))
    }else  if (!isvalidPhone(value)){
        callback(new Error('手机号码格式不对'))
    }else {
        callback()
    }
}
export default {
    name:'staffManage',
    data(){
        return{
            staffName:'',//筛选
            staffList:[],
            count:0,
            page:1,
            addDialog:false,
            addForm:{
                staffName:'',
                staffGender:'',
                staffAge:'',
                staffTel:'',
                password:'',
                passwordTwo:''
            },
            //添加员工，规则
            addStaff:{
                staffName:[{ required: true, trigger: 'blur', message: '请输入员工姓名' }],
                staffGender:[{ required: true, trigger: 'blur', message: '请选择员工性别' }],
                staffAge:[{ required: true, trigger: 'blur', message: '请输入员工年龄' }],
                staffTel:[{ required: true, trigger: 'blur', validator: validPhone }],
                password:[{ required: true, trigger: 'blur', message: '请输入密码' },{ min:6, trigger: 'blur', message: '密码不得少于6位' }],
                passwordTwo:[{ required: true, trigger: 'blur', message: '请再次输入密码' },{ min:6, trigger: 'blur', message: '密码不得少于6位' }]
            },
            loadingInstance:''
        }
    },
    mounted(){
        this.getStaffList(1);
    },
    methods:{
        //性别转换
        transfSex(row){
            switch(row.staffGender){
                case 'M':return '男';break;
                case 'F':return '女';break;
                case 'O':return '-';break;
            }
        },
        //获得员工列表
        getStaffList(page){
            this.$ajax.post(this.$domain.queryStaff,{
                staffName:this.staffName,
                page:page,
                rows:15
            })
            .then(ret=>{
                console.log(ret.data.data)
                if(ret.data.code==10){
                    this.staffList=ret.data.data.data;
                    this.count=ret.data.data.count;
                }
                else if(ret.data.code=='11'){
                    this.staffList=[];
                    this.count=0;
                }
                else if(ret.data.code=='401'){
                    this.$message.error('登录失效，请重新登录！');
                    this.$router.push({path:'/login'})
                }
                else{
                    console.log(ret.data)
                }
            })
        },
        //添加员工
        addStaffFn(){
            this.$refs['addForm'].validate((valid) => {
                if(valid){
                    if(this.addForm.password!=this.addForm.passwordTwo){
                        this.$message.error('两次密码输入不一致');
                        return;
                    }
                    this.loadingInstance=Loading.service({
                        text:'员工添加中...',
                        spinner:'el-icon-loading',
                        background:'rgba(0, 0, 0, 0.8)'
                    });
                    var obj={
                        staffName:this.addForm.staffName,
                        staffGender:this.addForm.staffGender,
                        staffAge:this.addForm.staffAge,
                        staffTel:this.addForm.staffTel,
                        password:this.$common.pwd99(this.addForm.password),
                        passwordTwo:this.$common.pwd99(this.addForm.passwordTwo)
                    }
                    this.$ajax.post(this.$domain.openAccount,obj)
                    .then(ret=>{
                        this.loadingInstance.close();
                        if(ret.data.code=10){
                            this.$message.success('添加员工成功');
                            this.cancel();
                            this.getStaffList(1);
                        }
                        else if(res.code=='14'){
                            this.$message.error('该账户已存在！');
                        }
                        else if(res.code=='401'){
                            this.$message.error('登录失效，请重新登录！');
                            this.$router.push({path:'/login'})
                        }
                        else{
                            console.log(res)
                        }
                    })
                }
            })
        },
        //删除员工
        deleteStaff(row){
            this.$confirm('此操作将删除该员工账号, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.loadingInstance=Loading.service({
                    text:'员工删除中...',
                    spinner:'el-icon-loading',
                    background:'rgba(0, 0, 0, 0.8)'
                });
                this.$ajax.post(this.$domain.delStaff,{
                    staffLoginId:row.staffLoginId
                })
                .then(ret=>{
                    this.loadingInstance.close();
                    if(ret.data.code==10){
                        this.$message.success('删除员工成功!');
                        this.getStaffList(1)
                    }
                    else if(ret.data.code=='401'){
                        this.$message.error('登录失效，请重新登录！');
                        this.$router.push({path:'/login'})
                    }
                    else{
                        console.log(ret.data.message)
                    }
                })
            })
            
        },
        //密码重置
        resetPwd(row){
            this.$prompt('请输入密码', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern:/^[0-9A-Za-z]{6,}$/,
                inputErrorMessage:'密码由数字和字母组成，且不得小于6位',
                inputType:'password'
            }).then(({ value }) => {
                this.$ajax.post(this.$domain.resetStaffPwd,{
                    staffLoginId:row.staffLoginId,
                    password:this.$common.pwd99(value)
                }).then((ret)=>{
                    console.log(ret.data)
                    var res=ret.data
                    if(res.code=="10"){
                        this.$message.success('重置成功！');
                    }
                    else if(ret.data.code=='401'){
                        this.$message.error('登录失效，请重新登录！');
                        this.$router.push({path:'/login'})
                    }
                    else{
                        console.log(ret.data.message)
                    }
                }).catch(()=>{
                    console.log("123")
                })

            }).catch((err)=>{
                console.log(err)
                console.log("中国加油！");
            })
        },
        //分页
        changePage(val){
            this.page=val;
            this.getStaffList(this.page);
        },
        cancel(){
            this.addDialog=false;
            this.addForm={
                staffName:'',
                staffGender:'',
                staffAge:'',
                staffTel:'',
                password:'',
                passwordTwo:''
            }
        }
    }
}
</script>

<style>
#staffManage{
    width:100%;
    min-width: 1200px;
    padding:0 10%;
    box-sizing: border-box;
}
#staffManage .breadcrumb{
    width:100%;
    margin:10px auto;
    padding:20px 0;
    box-sizing: border-box;
}
.radioGroup{
    text-align: left;
    margin-top:12px;
    width:100%;
}
</style>



// WEBPACK FOOTER //
// src/page/staffManage.vue